import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getWithdrawRequests } from '../withdrawRequestsEndpoints'
import { withdrawRequestKeys } from '../withdrawRequestsQueryKeys'
import type { GetWithdrawRequestsParams } from '../../types/withdrawRequestsTypes'

const DEFAULT_PAGE = 1
const DEFAULT_LIMIT = 10

export function useWithdrawRequestsListQuery(
  filters: MaybeRefOrGetter<Partial<GetWithdrawRequestsParams>>,
) {
  return useQuery({
    queryKey: () => withdrawRequestKeys.list(toValue(filters)),
    queryFn: () =>
      getWithdrawRequests({
        page: DEFAULT_PAGE,
        limit: DEFAULT_LIMIT,
        ...toValue(filters),
      }),
    placeholderData: keepPreviousData,
  })
}
